<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">
        お客様情報登録
      </v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">
        時計情報登録
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 3" step="3">
        症状登録
      </v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 4" step="4">
        依頼内容登録
      </v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 5" step="5">
        内容確認
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items   class="contents">
      <v-stepper-content step="1">
          <step1 @get-step1="getStep1Value"></step1>
      </v-stepper-content>

      <v-stepper-content step="2">
          <step2 @get-step2="getStep2Value"></step2>
      </v-stepper-content>

      <v-stepper-content step="3">
          <step3 @get-step3="getStep3Value"></step3>
      </v-stepper-content>
      <v-stepper-content step="4">
          <step4 @get-step4="getStep4Value"></step4>
      </v-stepper-content>
      <v-stepper-content step="5">
       <v-row justify="center">
          <v-col cols="12" sm="8" md="7" lg="5" xl="4">
          <v-card
          class="mb-12"
          color=""
          >
         <v-card-title>STEP:5 内容確認</v-card-title>
          <v-card-text>
            <v-container pt-n5 mt-0> 
              <v-row  dense>
                <v-col cols="3">
                  氏名：
                </v-col>
                <v-col cols="9" >
                  {{user.name_first}} {{user.name_last}}  様
                </v-col>                
               </v-row>
              <v-row  dense>               
                <v-col  cols="3">
                  ナマエ：
                </v-col>
                <v-col cols="9" >
                  {{user.name_first_kana}} {{user.name_last_kana}} 様
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="3" >
                  メール：
                </v-col>
                <v-col cols="9" >
                  {{user.email}}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" >
                パスワード：登録のパスワード
                </v-col>
              </v-row>
                 <v-row v-if="watch.brand" dense>
                <v-col cols="3" >
               ブランド名：
               </v-col>
               <v-col cols="9" >                   
               <span >{{watch.brand.brandname}}</span>
               </v-col>
               </v-row>
               <v-row dense  v-if="watch.brandSub">
               <v-col cols="3" >
                モデル名：
               </v-col>
               <v-col cols="9" > 
                <span>{{watch.brandSub.subname}}</span>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="3" >
                  ケース番号：
                 </v-col>
               <v-col cols="9" >
                {{watch.caseNo}}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="3" >
                機構：
                </v-col>
               <v-col cols="9" >                
                <span v-if="watch.mecha">
                  {{watch.mecha.name}}</span>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="3">
                 前回履歴：
                 </v-col>
               <v-col cols="9" v-if="watch.history"> 
               {{watch.history.name}}
                </v-col>
              </v-row>
              <v-row dense v-if="watch.images">
                <v-col cols="12" >
                写真：
                </v-col>
              </v-row>
              <v-row  no-gutters >
                <v-col  v-for="(image,i) in watch.images" :key="i" cols="12" sm="6" md="4" lg="4" xl="4">
                  <v-card>
                   <v-img :src="image.url" aspect-ratio="1" :contain="true"></v-img> 
                  </v-card>
                </v-col>
              </v-row>

              <v-row  v-if="conditions">
                <v-col cols="3">
                <span>時計本体症状:</span>
                </v-col>
                <v-col cols="9" >                
                   <v-chip v-for="(conditionWatch,index) in conditions.watch" :key="index">
                   <span>{{conditionWatch.name}}</span>
                    </v-chip>
                </v-col>
              </v-row>
              <v-row >
                <v-col cols="3">
                <span>外装症状:</span>
                </v-col>
                <v-col cols="9" >                
                   <v-chip v-for="(conditionOuter,index) in conditions.outer" :key="index">
                   <span>{{conditionOuter.name}}</span>
                    </v-chip>
                </v-col>
              </v-row>
               <v-row >
                <v-col cols="3">
                <span>バンド症状:</span>
                </v-col>
                <v-col cols="9" >                
                   <v-chip v-for="(conditionBand,index) in conditions.band" :key="index">
                   <span>{{conditionBand.name}}</span>
                    </v-chip>
                </v-col>
              </v-row>
               <v-row dense>
                <v-col cols="3">
                 その他：
                 </v-col>
               <v-col cols="9" > 
                    <span>{{conditions.other}}</span>                
                </v-col>
              </v-row>

               <v-row v-if="requests">
                <v-col cols="3">
                <span>時計本体依頼内容:</span>
                </v-col>
                <v-col cols="9" >                
                   <v-chip v-for="(requestWatch,index) in requests.watch" :key="index">
                   <span>{{requestWatch.name}}</span>
                    </v-chip>
                </v-col>
              </v-row>
              <v-row >
                <v-col cols="3">
                <span>外装依頼内容:</span>
                </v-col>
                <v-col cols="9" >                
                   <v-chip v-for="(requestOuter,index) in requests.outer" :key="index">
                   <span>{{requestOuter.name}}</span>
                    </v-chip>
                </v-col>
              </v-row>
               <v-row >
                <v-col cols="3">
                <span>バンド依頼内容:</span>
                </v-col>
                <v-col cols="9" >                
                   <v-chip v-for="(requestBand,index) in requests.band" :key="index">
                   <span>{{requestBand.name}}</span>
                    </v-chip>
                </v-col>
              </v-row>
               <v-row dense>
                <v-col cols="3">
                 その他依頼内容：
                 </v-col>
               <v-col cols="9" > 
                  <span>{{requests.other}}</span>   
                </v-col>
              </v-row>
            <v-row>
              <v-col cols="3"> 
                <v-btn text bottom left @click="e1 = 4">
                ←戻る
                </v-btn>
              </v-col>
              <v-col cols="6"> 
                 <v-btn
                 color="primary"
                 bottom right
                 @click="estimateRequest()"
                 :loading="isRequest"
                 :disabled="isRequest"

                >この内容で申し込む
                </v-btn>  </v-col>
              <v-col cols="3">

              </v-col>
            </v-row>
            </v-container>
          </v-card-text>
       </v-card>
         </v-col>
        </v-row>
      </v-stepper-content>
 
    </v-stepper-items>
  </v-stepper>
</template>
<script>
import doAxios from '@/components/modules/AxiosPost'
import setAddress from '@/components/modules/setAddress'
import Step1 from '@/components/template/Step1.vue'
import Step2 from '@/components/template/Step2.vue'
import Step3 from '@/components/template/Step3.vue'
import Step4 from '@/components/template/Step4.vue'

  export default {
    data () {

      return {
        e1: 1,
        user:[],
        watch:{},
        brand:{},
        brandsub:{},
        brandname:"",
        subname:"",
        conditions:{},
        requests:{},
        val:[],
        ChildMessage:[],
        ChildMessageSub:[],
        ChildImages:[],
        watch_urls:[],
        watchs:[],
        results:[],
        isRequest:false
        
      }      
    },
    mixins: [doAxios,setAddress],
    components: {
      Step1,
      Step2,
      Step3,
      Step4
    },
       
  methods: {

    getStep1Value(payload) {
    this.user= payload.user;
    this.e1 = payload.btn

   },
    getStep2Value(payload) {
    this.watch = payload.watch;
    this.e1 = payload.btn
   },
    getStep3Value(payload) {
    this.conditions = payload.conditions;
    this.e1 = payload.btn
   },
    getStep4Value(payload) {
    this.requests = payload.requests;
    this.e1 = payload.btn
   },
   async estimateRequest(){
        this.isRequest = true
        if(this.watch.images==""){

           this.watch_urls =""
        }else{
           this.watch_urls =[]
           this.watch.images.map(value =>  this.watch_urls.push(value.url))

        }
          const setData = {
             "user": {
               "user_email": this.user.email,
               "user_password": this.user.password,
               "user_name_first" : this.user.name_first,
               "user_name_last" : this.user.name_last,
               "user_name_first_kana" : this.user.name_first_kana,
               "user_name_last_kana" : this.user.name_last_kana,              
               },

             "watch":{ 
                "brand": this.watch.brand,
                "model":this.watch.brandSub,
                "mecha": this.watch.mecha,
                "history":this.watch.history,
                "case_no":this.watch.caseNo,
                "condition_comment":this.conditions.other,
                "request_comment":this.requests.other
                },
              "conditions":this.conditions,
              "requests":this.requests,
              "watch_image" :this.watch_urls,
              "staff_entry":0
            };

          const php = 'set_new_entry/setNewEntry';
          this.results= await this.doAxios({php,setData});
          if(this.results !== null ){
          this.$store.dispatch('authToken', this.results.utoken)
          this.$store.dispatch('authId', this.results.uid)  
          this.$store.dispatch('authLoginToken', 'login')   
          this.isRequest = false   
          this.$router.push('/Thanks')
          }
        this.isRequest = false
   }
  },
  mounted:function(){
      this.$store.dispatch('authLoginToken', 'login')
      //戻るボタン無効可
      this.setAddress('entryForm')
      window.history.pushState(null, null, null);
      window.addEventListener("popstate", function() {
      window.history.pushState(null, null, null);
        return;
      });
}
  
}
  </script>
  <style scoped>
.contents{
    background: #eaf3ff;
    padding-bottom: 30px;
}
</style>